import * as React from 'react';
import PropTypes from 'prop-types';
import logo from "../assets/tom-logo-icon-black.jpg"

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import { AppProvider } from '@toolpad/core/AppProvider';

import MenuIcon from '@mui/icons-material/Menu';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import ViewTimelineOutlinedIcon from '@mui/icons-material/ViewTimelineOutlined';
import MarkAsUnreadOutlinedIcon from '@mui/icons-material/MarkAsUnreadOutlined';


const drawerWidth = 240;
const navItems = ['Home', 'Pricing', 'Contact', 'Login'];

const setTheme = createTheme({
    cssVariables: {
        colorSchemeSelector: 'data-toolpad-color-scheme',
    },
    colorSchemes: {
        light: {
            palette: {
                background: {
                    default: '#F9F9FE',
                    paper: '#EEEEF9',
                },
            },
        },
        dark: {
            palette: {
                background: {
                    default: '#121212',
                    paper: '#121212',
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 800,
            md: 1000,
            lg: 1200,
            xl: 1536,
        },
    },
});

function DrawerAppBar({ page }) {
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ my: 2 }}>
            MUI
        </Typography>
        <Divider />
        <List>
            {navItems.map((item) => (
            <ListItem key={item} disablePadding>
                <ListItemButton sx={{ textAlign: 'center' }}>
                <ListItemText primary={item} />
                </ListItemButton>
            </ListItem>
            ))}
        </List>
        </Box>
    );

    //   const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar component="nav">
                <AppProvider theme={setTheme}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, cursor: 'default', display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', textDecoration: 'none' }} component={Link} to="/">
                        <img
                            // src="/src/assets/tom-logo-icon-black.jpg"
                            src={logo}
                            alt="Takeoff Monkey Widgets Logo"
                            style={{ height: '3em', marginRight: '1.5em' }}
                        />
                        <Typography
                            variant="h6"
                            sx={{ display: { xs: 'none', sm: 'block' } }}
                        >
                            Takeoff Monkey Widgets
                        </Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}></Box>
                    <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
                        <MenuItem component={Link} to="/#about">
                            <QuestionAnswerOutlinedIcon />
                            <p>&nbsp;&nbsp;About</p>
                        </MenuItem>
                        <MenuItem component={Link} to="/#pricing">
                            <ViewTimelineOutlinedIcon />
                            <p>&nbsp;&nbsp;Pricing</p>
                        </MenuItem>
                        <MenuItem component={Link} to="/#contact">
                            <MarkAsUnreadOutlinedIcon />
                            <p>&nbsp;&nbsp;Contact</p>
                        </MenuItem>
                        <MenuItem component={Link} to="/login">
                            <LoginOutlinedIcon />
                            <p>&nbsp;&nbsp;Login</p>
                        </MenuItem>
                    </Box>
                </Toolbar>
                </AppProvider>
            </AppBar>
            <nav>
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
            {/* <Box component="main" sx={{ p: 3 }}> */}
                <Toolbar />
                {page}
            {/* </Box> */}
        </Box>
    );
}

export default DrawerAppBar;